import React from 'react';
import { Item } from "semantic-ui-react"
import { Link } from "react-router-dom"

export default class ContactUs extends React.Component {

  render() {
    return (
      <Item as={Link} to='/contactus'>Contact Us</Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ContactUs/index.js